import * as React from "react";
import usePromise from "../hooks/usePromise";
import { getUser } from "../../libs/user";
import { Route, RouteComponentProps } from "react-router";
import CommissionUser from "./CommissionUser";
import Loader from "../core/Loader";
import { getEmployeeCommissions } from "../../libs/commission_calculator";
import CommissionMonthContainer from "./CommissionMonthContainer";

interface IProps extends RouteComponentProps {
  commissionUserId: string;
}

function CommissionUserContainer({ commissionUserId, match }: IProps) {
  const [user, { loading: loadingUser }] = usePromise(() =>
    getUser(commissionUserId)
  );

  const [commissions, commisionsPromise] = usePromise(() =>
    getEmployeeCommissions(commissionUserId)
  );

  return (
    <>
      <Route
        path={match.url}
        exact
        render={props =>
          loadingUser ? (
            <Loader />
          ) : (
            <CommissionUser
              user={user}
              commissions={commissions}
              commissionsPromise={commisionsPromise}
              {...props}
            />
          )
        }
      />
      <Route
        path={`${match.url}/:commissionMonthId`}
        render={props =>
          loadingUser || commisionsPromise.loading ? (
            <Loader />
          ) : (
            <CommissionMonthContainer
              commissionMonthId={props.match.params.commissionMonthId}
              isManaging={true}
              {...props}
            />
          )
        }
      />
    </>
  );
}

export default CommissionUserContainer;



// WEBPACK FOOTER //
// ./app/javascript/components/commission_calculator/CommissionUserContainer.tsx